function base64ToBlob(base64String, fileName) {
	
	const parts = base64String.split(';base64,')
	const contentType = parts[0].split(':')[1]
	const byteCharacters = atob(parts[1])
	const byteArrays = []
	
	for (let offset = 0; offset < byteCharacters.length; offset += 1024) {
		const slice = byteCharacters.slice(offset, offset + 1024)
		
		const byteNumbers = new Array(slice.length)
		for (let i = 0; i < slice.length; i++) {
			byteNumbers[i] = slice.charCodeAt(i)
		}
		
		const byteArray = new Uint8Array(byteNumbers)
		byteArrays.push(byteArray)
	}
	
	const blob = new Blob(byteArrays, { type: contentType })
	
	// Attach filename to the Blob object
	blob.name = fileName
	
	return blob
}

export default base64ToBlob
